/* eslint-disable */
import { getLocale, trackMessageCall, experimentalMiddlewareLocaleSplitting, isServer, experimentalStaticLocale } from '../runtime.js';
/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

const en_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molar mass is the mass of one mole of a substance, in grams per mole. It equals the sum of the standard atomic weights of every atom in the chemical formula.`)
};

const es_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La masa molar es la masa de un mol de una sustancia, en gramos por mol. Es igual a la suma de los pesos atómicos estándar de cada átomo en la fórmula química.`)
};

const de_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die molare Masse ist die Masse eines Mols einer Substanz, in Gramm pro Mol. Sie entspricht der Summe der Standardatomgewichte aller Atome in der chemischen Formel.`)
};

const nl_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Molaire massa is de massa van één mol van een stof, in gram per mol. Het is gelijk aan de som van de standaardatoomgewichten van elk atoom in de chemische formule.`)
};

const fr_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La masse molaire est la masse d'une mole d'une substance, en grammes par mole. Elle est égale à la somme des masses atomiques standards de chaque atome de la formule chimique.`)
};

const it_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La massa molare è la massa di una mole di sostanza, in grammi per mole. Equivale alla somma dei pesi atomici standard di ogni atomo nella formula chimica.`)
};

const pt_br2_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Massa molar é a massa de um mol de uma substância, em gramas por mol. É igual à soma dos pesos atômicos padrão de todos os átomos na fórmula química.`)
};

const pt_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A massa molar é a massa de um mole de uma substância, em gramas por mole. É igual à soma das massas atómicas padrão de todos os átomos da fórmula química.`)
};

const ja_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`モル質量は物質1モルの質量で、1モルあたりのグラム数で表されます。化学式中のすべての原子の標準原子量の合計に等しくなります。`)
};

const zh_mw_faq_a1 = /** @type {(inputs: {}) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`摩尔质量是一摩尔物质的质量，单位为克每摩尔。它等于化学式中每个原子的标准原子量之和。`)
};

/**
* This function has been compiled by [Paraglide JS](https://inlang.com/m/gerre34r).
*
* - Changing this function will be over-written by the next build.
*
* - If you want to change the translations, you can either edit the source files e.g. `en.json`, or
* use another inlang app like [Fink](https://inlang.com/m/tdozzpar) or the [VSCode extension Sherlock](https://inlang.com/m/r7kp499g).
* 
* @param {{}} inputs
* @param {{ locale?: "en" | "es" | "de" | "nl" | "fr" | "it" | "pt-BR" | "pt" | "ja" | "zh" }} options
* @returns {LocalizedString}
*/
/* @__NO_SIDE_EFFECTS__ */
export const mw_faq_a1 = (inputs = {}, options = {}) => {
	if (experimentalMiddlewareLocaleSplitting && isServer === false) {
		return /** @type {any} */ (globalThis).__paraglide_ssr.mw_faq_a1(inputs) 
	}
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	trackMessageCall("mw_faq_a1", locale)
	if (locale === "en") return en_mw_faq_a1(inputs)
	if (locale === "es") return es_mw_faq_a1(inputs)
	if (locale === "de") return de_mw_faq_a1(inputs)
	if (locale === "nl") return nl_mw_faq_a1(inputs)
	if (locale === "fr") return fr_mw_faq_a1(inputs)
	if (locale === "it") return it_mw_faq_a1(inputs)
	if (locale === "pt-BR") return pt_br2_mw_faq_a1(inputs)
	if (locale === "pt") return pt_mw_faq_a1(inputs)
	if (locale === "ja") return ja_mw_faq_a1(inputs)
	return zh_mw_faq_a1(inputs)
};